import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import * as profile from '../../../modules/customer/profile';
import { softwareProducts, hardwareProducts, orderProducts } from '../../../modules/customer';
import ActionButton from '../../components/ActionButton';
import LoadingPanel from '../../components/LoadingPanel';
import Box from '../profilePage/components/Box';
import BoxRow from '../profilePage/components/BoxesRow';
import ProductSelector from './ProductSelector';
import { ui } from '../../../modules';

class OrderProducts extends React.Component {

    getButtons = () => [
        <ActionButton to={this.props.getUrl('serials')} title="Serienumre" icon="key" key="serialsKey"/>
    ]

    render = () =>
        <BoxRow>
            <Box label="Legg til produkter" buttons={this.getButtons()}>
                <div className="container-fluid main-container">
                    <div className='row'>
                        <div className='col-md-4'>
                            <h4>Abonnement</h4>
                            {this.props.isSoftwareLoading && <LoadingPanel />}
                            {this.props.softwareProductList.map((product, key) => (
                                <div key={key}>{product.name}</div>
                            ))}
                            {this.props.softwareProductList.length === 0 && !this.props.isSoftwareLoading && <span>Ingen produkter</span>}
                            <h4>Utstyr</h4>
                            {this.props.isHardwareLoading && <LoadingPanel />}
                            {this.props.hardwareProductList.map((product, key) => (
                                <div key={key}>{product.name}</div>
                            ))}
                            {this.props.hardwareProductList.length === 0 && !this.props.isHardwareLoading && <span>Ingen produkter</span>}
                        </div>
                        <div className='col-md-8'>
                            <ProductSelector />
                        </div>
                    </div>
                </div>
            </Box>
        </BoxRow>
}

const mapStateToProps = (state, props) => ({
    id: profile.selectors.getCustomerID(state),
    softwareProductList: softwareProducts.selectors.getSoftwareProductsList(state),
    hardwareProductList: hardwareProducts.selectors.getHardwareProductList(state),
    isSoftwareLoading: softwareProducts.selectors.isLoading(state),
    isHardwareLoading: hardwareProducts.selectors.isLoading(state),
    getUrl: (page) => ui.selectors.getUrl(state, page)
});

const mapDispatchToProps = (dispatch, props) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(OrderProducts);
